<template>
  <div class="home">
    <v-content>
      <section>
        <v-parallax src="images/landing-image.jpg" height="600">
          <v-layout
            column
            align-center
            justify-center
            class="white--text"
          >
            <img src="logo_main_page.png" height="100px">
            <h1 class="white--text display-3 font-weight-medium text-xs-center">panparawan</h1>
            <h5 class="white--text headline text-xs-center">projektowanie i wyposażenie wnętrz</h5>
          </v-layout>
        </v-parallax>
      </section>

      <ProjectsList id="projects"></ProjectsList>
      <ContactUs id="contact"></ContactUs>
    </v-content>
 </div>
</template>

<script>
// @ is an alias to /src
import ProjectsList from "@/components/ProjectsList.vue";
import ContactUs from "@/components/ContactUs.vue";

export default {
  name: "home",
  components: {
    ProjectsList,
    ContactUs
  }
};
</script>

<style scoped>
h1 {
  line-height: 1 !important;
}

</style>
